import { Controller } from "@hotwired/stimulus"
import RequestHelper from "../helpers/request_helper"

export default class extends Controller {
  visitCollection(event) {
    if (!(event.target.localName === "i" || event.target.localName === "button" || event.target.localName === "a")) {
      event.preventDefault();
      // S3: the whole destination is taken wholesale out of a data attribute, so it is asserted
      // same-origin before navigating even though `_collection.html.haml` only ever renders
      // `collection_path(collection)` into it. This controller has no error UI of its own and the
      // click is a plain navigation, so the failing branch simply does not navigate.
      const destination = event.currentTarget.dataset.href;
      if (RequestHelper.isSameOriginUrl(destination)) {
        window.location.href = destination;
      }
    }
  }
}
